
import { defineComponent } from "vue";

export default defineComponent({
    name: "ValidateRecordButton",
    props: {
        text: String,
        background: {
            type: String,
            required: false,
            default: "transparent"
        },
        textColor: {
            type: String,
            required: false,
            default: "inherit"
        },
        height: {
            type: String,
            required: false,
            default: "48px"
        }
    },
    computed: {
        getStyle() {
            return {
                "--background": this.background,
                "--height": this.height,
                "--color": this.textColor
            };
        }
    }
});
